"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTypingIndicator = useTypingIndicator;
var _react = require("react");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// Wraps the adapter's emitTyping/emitStopTyping + the incoming
// usertyping/userstoptyping listeners behind one hook, replacing the inline
// 3-second debounce logic that lived directly in the old chat panel.
function useTypingIndicator() {
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    adapter = _ref.adapter,
    roomId = _ref.roomId,
    senderId = _ref.senderId,
    senderLabel = _ref.senderLabel,
    _ref$debounceMs = _ref.debounceMs,
    debounceMs = _ref$debounceMs === void 0 ? 3000 : _ref$debounceMs;
  const isTypingRef = (0, _react.useRef)(false);
  const timeoutRef = (0, _react.useRef)(null);
  const _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    typingUser = _useState2[0],
    setTypingUser = _useState2[1];
  const notifyTyping = (0, _react.useCallback)(() => {
    if (!adapter || !roomId) return;
    if (!isTypingRef.current) {
      isTypingRef.current = true;
      adapter.emitTyping({
        chatroomid: roomId,
        senderid: senderId,
        senderlabel: senderLabel
      });
    }
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      isTypingRef.current = false;
      adapter.emitStopTyping({
        chatroomid: roomId,
        senderid: senderId,
        senderlabel: senderLabel
      });
    }, debounceMs);
  }, [adapter, roomId, senderId, senderLabel, debounceMs]);
  const notifyStopTyping = (0, _react.useCallback)(() => {
    clearTimeout(timeoutRef.current);
    if (adapter && roomId && isTypingRef.current) {
      isTypingRef.current = false;
      adapter.emitStopTyping({
        chatroomid: roomId,
        senderid: senderId,
        senderlabel: senderLabel
      });
    }
  }, [adapter, roomId, senderId, senderLabel]);
  (0, _react.useEffect)(() => {
    if (!adapter) return undefined;
    const offTyping = adapter.onTyping(_ref2 => {
      let senderid = _ref2.senderid,
        senderlabel = _ref2.senderlabel;
      setTypingUser({
        id: senderid,
        label: senderlabel
      });
    });
    const offStopTyping = adapter.onStopTyping(() => setTypingUser(null));
    return () => {
      offTyping === null || offTyping === void 0 || offTyping();
      offStopTyping === null || offStopTyping === void 0 || offStopTyping();
      clearTimeout(timeoutRef.current);
    };
  }, [adapter]);
  return {
    typingUser,
    notifyTyping,
    notifyStopTyping
  };
}